import type { ApiApp, ApiDataResponse, GetAppsByFlavorQuery } from '@app/packages/internalApi/types'
import { createInternalApiAction, encode, endpoint } from '@app/packages/internalApi/utils'

export const getAppsByFlavor = (flavor: string, query: GetAppsByFlavorQuery) =>
  createInternalApiAction('getAppsByFlavor', dispatch =>
    dispatch<ApiDataResponse<ApiApp>>({
      method: 'GET',
      endpoint: endpoint(encode`/internal/api/v1/apps/${flavor}`, query),
    })
  )
